// extracted by mini-css-extract-plugin
export default {"toggle":"toggle--Rih96aA0"};